module.exports = global["TealiumHelper"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./tealium.js");